import request from '@/utils/httpRequest'
// 保存banner信息
export function saveConfigInfo(url, data) {
  return request({
    url,
    method: 'post',
    data
  })
}
// 保存banner信息
export function updateConfigInfo(url, data) {
  return request({
    url,
    method: 'post',
    data
  })
}
// banner移动
export function bannerMove(data) {
  return request({
    url: `/bannerInfo/moveItem`,
    method: 'post',
    data
  })
}

// 发布banner
export function bannerOperate(data) {
  return request({
    url: `/bannerInfo/publish`,
    method: 'post',
    data
  })
}
// 删除banner
export function bannerDelete(id) {
  return request({
    url: `/bannerInfo/delete/${id}`,
    method: 'post',
    data: {}
  })
}

// 获取banner分页列表
export function getBannerList(params) {
  return request({
    url: `/bannerInfo/listPage`,
    method: 'get',
    params
  })
}
// 获取banner信息详情
export function getConentDetail(url, params) {
  return request({
    url,
    method: 'get',
    params
  })
}

// 上传图片
export function uploadImage(data) {
  return request({
    url: '/upload',
    type: 'file',
    method: 'post',
    data
  })
}

// 提交审批
export function approveOpreate(data) {
  return request({
    url: '/approve/commitApprove',
    method: 'post',
    data
  })
}
